import { useState, useEffect } from 'react'
import { useIntl, defineMessages } from 'react-intl'
import { useQuery } from '@apollo/client'
import { isEmpty } from 'lodash'

import { Autocomplete } from 'components/v2/Autocomplete'
import { GET_COMBO_ITEMS_AUTOCOMPLETE } from 'resolvers/items'

const messages = defineMessages({
  error: {
    id: 'spanish.comboItems.autocomplete.error',
    defaultMessage: 'Hubo un error al cargar los combos'
  },
  empty: {
    id: 'spanish.comboItems.autocomplete.empty',
    defaultMessage: 'No combos encontrados'
  }
})

export const getComboItemLabel = (item = {}): TSFixMe => {
  // @ts-expect-error TS(2559) FIXME Remove this comment to see the full error message
  if (!item.name) {
    return ''
  }

  // @ts-expect-error TS(2559) FIXME Remove this comment to see the full error message
  return item.name
}

export const ComboItemAutocomplete = ({
  companyId,
  showOnlyActive,
  filteredItemIds = [],
  ...props
}: TSFixMe): TSFixMe => {
  const intl = useIntl()
  const [pattern, setPattern] = useState('')
  const { data, loading, error, refetch } = useQuery(GET_COMBO_ITEMS_AUTOCOMPLETE, {
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-first',
    variables: {
      companyId
    }
  })

  useEffect((): TSFixMe => {
    refetch()
  }, [])

  let shownItems =
    (data &&
      !isEmpty(data.comboItemsAutocomplete) &&
      data.comboItemsAutocomplete.filter((comboItem: TSFixMe): TSFixMe => {
        if (showOnlyActive && !comboItem.isActive) {
          return false
        }
        return getComboItemLabel(comboItem).toLowerCase().indexOf(pattern.toLowerCase()) > -1
      })) ||
    []

  if (!isEmpty(filteredItemIds)) {
    shownItems = shownItems.filter(({ id }: TSFixMe): TSFixMe => !filteredItemIds.includes(id))
  }

  const handleChange = (item: TSFixMe, { inputValue = '' } = {}): TSFixMe => {
    setPattern(inputValue)

    if (!isEmpty(item)) {
      props.onChange(item)
    } else {
      props.onChange({
        id: '',
        name: ''
      })
    }
  }

  return (
    <Autocomplete
      {...props}
      items={shownItems}
      getItemLabel={(item): TSFixMe => getComboItemLabel(item)}
      loading={loading}
      error={error}
      errorMessage={intl.formatMessage(messages.error)}
      emptyMessage={intl.formatMessage(messages.empty)}
      onChange={handleChange}
    />
  )
}
